var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.63C14.21 10.32 13.03 11.2 12 12.26C10.97 11.19 9.79 10.31 8.5 9.63C8.74 6.86 9.92 4.14 12.06 2C14.18 4.12 15.31 6.84 15.5 9.63ZM12 15.45C14.15 12.17 17.82 10 22 10C22 20 12.68 21.88 12 22C11.32 21.89 2 20 2 10C6.18 10 9.85 12.17 12 15.45ZM12.05 5.19C11.39 6.23 10.93 7.38 10.68 8.58L12 9.55L13.35 8.57C13.12 7.37 12.68 6.22 12.05 5.19ZM12 19.97C12 19.97 18 19 19.74 12.25C14 14 12 19.1 12 19.1C12 19.1 9 13 4.26 12.26C6 19 12 19.97 12 19.97Z",
    fill: "#7B809A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.5d972900bfe97c49e5669358e8824a04.svg";
export { ForwardRef as ReactComponent };